module.exports = __webpack_public_path__ + "static/media/booking_with_phone.3dcd515c.jpg";